
<div class="row" style="margin-top:5px;">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12"><span class="dx-field-label" style="color:red;">{{__sExchangeRateWarningMessage}}</span></div>
    </div>
  </div>
</div>

<div class="row" style="padding-top:5px;">
  <div class="dx-field col-md-5">
    <div class="dx-field-label select-view-label">Select View</div>
    <div class="dx-field-value">
      <dx-select-box id="cbGeneralType"
                     [(value)]="__oQuantitativeView"
                     valueExpr="text"
                     displayExpr="text"
                     [searchEnabled]="true"
                     [dataSource]="__oQuantitativeViews">
      </dx-select-box>
    </div>
  </div>
</div>

<div class="container-fluid container-scroll" style="padding:0px;" >

  <!--<div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px">
    <div class="col-lg-2 col-md-2 col-sm-2">
      <span class="dx-field-label">Quantitative Factors</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:center;">
      <span class="dx-field-label">Original Value</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:center;">
      <span class="dx-field-label">Adjusted Value</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:center;">
      <span class="dx-field-label">Score (SC)</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:center;">
      <span class="dx-field-label">Weight (SW)</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:center;">
      <span class="dx-field-label">Weighted Score</span>
    </div>
  </div>-->

  <div class="row margin-0px padding0px" style="padding-left:2.3rem;margin-top:5px;width: 130rem;">
    <div class="col-md-3 col-lg-3 col-sm-3">
      <div class="row text-center">
        <div class="col-md-6"><span class="dx-field-label">Quantitative Factors</span></div>
        <div class="col-md-6" *ngIf="__oQuantitativeView === 'Financial Group'"><span class="dx-field-label">Score Card Group</span></div>
        <div class="col-md-6" *ngIf="__oQuantitativeView === 'Score Card Group'"><span class="dx-field-label">Financial Group</span></div>
      </div>
    </div>
    <div class="col-md-3 col-lg-3 col-sm-3">
      <div class="row text-center">
        <div class="col-md-6"><span class="dx-field-label">Score Card</span></div>
        <div class="col-md-6"><span class="dx-field-label">Original Value</span></div>
      </div>
    </div>
    <div class="col-md-3 col-lg-3 col-sm-3">
      <div class="row text-center">
        <div class="col-md-6"><span class="dx-field-label">Adjusted Value</span></div>
        <div class="col-md-6"><span class="dx-field-label">Score (SC)</span></div>
      </div>
    </div>
    <div class="col-md-3 col-lg-3 col-sm-3">
      <div class="row text-center">
        <div class="col-md-6"><span class="dx-field-label">Weight (SW)</span></div>
        <div class="col-md-6"><span class="dx-field-label">Weighted Score</span></div>
      </div>
    </div>
  </div>
  

  <div *ngIf="__oQuantitativeView === 'Financial Group'" style="margin-top:5px;width: 130rem;">
    <div *ngFor="let group of __oQuantitativeGroup" >

      <fieldset style="margin-top:5px;margin-left:15px;">
        <legend>{{group.GroupName}}</legend>


        <div class="col-md-3">
          <div class="row">
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAFinancialGroup" class="ColumnStyleDynamic">
                  <span>{{item.FinancialCategoryAlias}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAFinancialGroup" class="ColumnStyleDynamic">
                  <span>{{item.FAScoreCardGroup}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="row">
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAFinancialGroup" class="ColumnStyleDynamic">
                  <span>{{item.FAScoreCard}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView" style="text-align:center;">
                <div *ngIf="group.GroupName == item.FAFinancialGroup" class="ColumnStyleDynamic">

                  <dx-number-box [step]="0" [format]="item.FormatString" [(value)]="item.OriginalValue" [ngClass]="{'negativeFontColor' : __sExchangeRateWarningMessage != '' && item.FormatString != '#,##0.00%'}" [disabled]="__sQuantitativeControlState != 'Not Approve State' || item.IsScored === 0" style="text-align:right;" (onChange)="TextAreaOnChangeOriginal(item.lFAScoringModelFinancialViewId)"></dx-number-box>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="row">
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAFinancialGroup" class="ColumnStyleDynamic">

                  <dx-number-box [step]="0" [format]="item.FormatString" [(value)]="item.AdjustedValue" [ngClass]="{'negativeFontColor' : __sExchangeRateWarningMessage != '' && item.FormatString != '#,##0.00%'}" [disabled]="__sQuantitativeControlState == 'Not Approve State' || item.IsScored === 0" style="text-align:right;" (onChange)="TextAreaOnChange(item.lFAScoringModelFinancialViewId)"></dx-number-box>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAFinancialGroup" [ngStyle]="{'visibility':item.IsScored === 1 ? 'visible':'hidden'}" class="ColumnStyleDynamic">

                  <dx-number-box [step]="0" format="#,##0.00" [(value)]="item.Score" [disabled]="true" style="text-align:right;"></dx-number-box>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="row">
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAFinancialGroup" [ngStyle]="{'visibility':item.IsScored === 1 ? 'visible':'hidden'}" class="ColumnStyleDynamic">

                  <dx-number-box [step]="0" format="#,##0.00" [(value)]="item.Weight" [disabled]="true" style="text-align:right;"></dx-number-box>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAFinancialGroup" [ngStyle]="{'visibility':item.IsScored === 1 ? 'visible':'hidden'}" class="ColumnStyleDynamic">

                  <dx-number-box [step]="0" format="#,##0.00" [(value)]="item.WeightedScore" [disabled]="true" style="text-align:right;"></dx-number-box>
                </div>
              </div>
            </div>
          </div>
        </div> 

      </fieldset>
    </div>
  </div>

  <div style="width:130rem" *ngIf="__oQuantitativeView === 'Score Card Group'">
    <div *ngFor="let group of __oQuantitativeScoreCardGroup">

      <fieldset style="margin-top:5px;margin-left:15px;">
        <legend>{{group.GroupName}}</legend>


        <div class="col-md-3">
          <div class="row">
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAScoreCardGroup" class="ColumnStyleDynamic">
                  <span>{{item.FinancialCategoryAlias}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAScoreCardGroup" class="ColumnStyleDynamic">
                  <span>{{item.FAFinancialGroup}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="row">
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAScoreCardGroup" class="ColumnStyleDynamic">
                  <span>{{item.FAScoreCard}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView" style="text-align:center;">
                <div *ngIf="group.GroupName == item.FAScoreCardGroup" class="ColumnStyleDynamic">

                  <dx-number-box [step]="0" [format]="item.FormatString" [(value)]="item.OriginalValue" [ngClass]="{'negativeFontColor' : __sExchangeRateWarningMessage != '' && item.FormatString != '#,##0.00%' }" [disabled]="__sQuantitativeControlState != 'Not Approve State' || __bReadOnly === 1" style="text-align:right;" (onChange)="TextAreaOnChangeOriginal(item.lFAScoringModelFinancialViewId)"></dx-number-box>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="row">
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAScoreCardGroup" class="ColumnStyleDynamic">

                  <dx-number-box [step]="0" [format]="item.FormatString" [(value)]="item.AdjustedValue" [ngClass]="{'negativeFontColor' : __sExchangeRateWarningMessage != '' && item.FormatString != '#,##0.00%' }" [disabled]="__sQuantitativeControlState == 'Not Approve State' || __bReadOnly === 1" style="text-align:right;" (onChange)="TextAreaOnChange(item.lFAScoringModelFinancialViewId)"></dx-number-box>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAScoreCardGroup" [ngStyle]="{'visibility':item.IsScored === 1 ? 'visible':'hidden'}" class="ColumnStyleDynamic">

                  <dx-number-box [step]="0" format="#,##0.00" [(value)]="item.Score" [disabled]="true" style="text-align:right;"></dx-number-box>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="row">
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAScoreCardGroup" [ngStyle]="{'visibility':item.IsScored === 1 ? 'visible':'hidden'}" class="ColumnStyleDynamic">

                  <dx-number-box [step]="0" format="#,##0.00" [(value)]="item.Weight" [disabled]="true" style="text-align:right;"></dx-number-box>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div *ngFor="let item of __oFAScoringModelFinancialView">
                <div *ngIf="group.GroupName == item.FAScoreCardGroup" [ngStyle]="{'visibility':item.IsScored === 1 ? 'visible':'hidden'}" class="ColumnStyleDynamic">

                  <dx-number-box [step]="0" format="#,##0.00" [(value)]="item.WeightedScore" [disabled]="true" style="text-align:right;"></dx-number-box>
                </div>
              </div>
            </div>
          </div>
        </div>

      </fieldset>
    </div>
  </div>

  <!--<div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px">
    <div *ngFor="let group of __oQuantitativeGroup">

      <fieldset style="margin:5px;">
        <legend>{{group.GroupName}}</legend>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelFinancialView">
            <div *ngIf="group.GroupName == item.FAScoreCardGroup" style="margin:2px;height:40px;">
              <span [title]="item.ScoreCardGroupInfo">{{item.FinancialCategoryAlias}}</span>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelFinancialView" style="text-align:center;">
            <div *ngIf="group.GroupName == item.FAScoreCardGroup" style="margin:2px;height:40px;">              
              <dx-number-box format="#,##0.##" [(value)]="item.OriginalValue" [disabled]="__sQuantitativeControlState != 'Not Approve State'" style="text-align:right;" (onChange)="TextAreaOnChangeOriginal(item.lFAScoringModelFinancialViewId)"></dx-number-box>
            </div>            
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelFinancialView">

            <div *ngIf="group.GroupName == item.FAScoreCardGroup" style="margin:2px;height:40px;">              
              <dx-number-box format="#,##0.##" [(value)]="item.AdjustedValue" [disabled]="__sQuantitativeControlState == 'Not Approve State'" style="text-align:right;" (onChange)="TextAreaOnChange(item.lFAScoringModelFinancialViewId)"></dx-number-box>
            </div>           

          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelFinancialView">
            <div *ngIf="group.GroupName == item.FAScoreCardGroup" [ngStyle]="{'visibility':item.IsScored === 1 ? 'visible':'hidden'}" style="margin:2px;height:40px;" >
              <dx-number-box format="#,##0.##" [(value)]="item.Score" [disabled]="true" style="text-align:right;"></dx-number-box>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelFinancialView">
            <div *ngIf="group.GroupName == item.FAScoreCardGroup" [ngStyle]="{'visibility':item.IsScored === 1 ? 'visible':'hidden'}" style="margin:2px;height:40px;" >
              <dx-number-box format="#,##0.##" [(value)]="item.Weight" [disabled]="true" style="text-align:right;"></dx-number-box>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelFinancialView">
            <div *ngIf="group.GroupName == item.FAScoreCardGroup" [ngStyle]="{'visibility':item.IsScored === 1 ? 'visible':'hidden'}" style="margin:2px;height:40px;" >
              <dx-number-box format="#,##0.##" [(value)]="item.WeightedScore" [disabled]="true" style="text-align:right;"></dx-number-box>
            </div>
          </div>
        </div>

      </fieldset>
    </div>
  </div>-->


</div>

<dx-load-panel id="pnlLoad"
               shadingColor="rgba(0,0,0,0.4)"
               [position]="{ at: 'center' }"
               [(visible)]="__bIsLoadingVisible"
               [showIndicator]="true"
               [showPane]="true"
               [shading]="true"
               [hideOnOutsideClick]="false"
               [height]="75"
               [width]="150"
               message="Please Wait...">
</dx-load-panel>
